import { makeAutoObservable, runInAction } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { ChatbotListStore } from 'pages/chatbot'
import { CallingStore } from 'pages/chatbot/pages/calling/pages/index/store/CallingStore'
import { type IAgentType } from 'pages/chatbot/store/type'

export class ListLayoutStore {
  readonly chatbotListStore
  readonly callingStore
  constructor(private initType: IAgentType, readonly entities: IEntitiesStore) {
    this.chatbotListStore = new ChatbotListStore()
    this.callingStore = new CallingStore(entities)
    makeAutoObservable(this)
  }

  private _disabledLoadingOnMount = true
  get disabledLoadingOnMount() {
    return this._disabledLoadingOnMount
  }
  init = async () => {
    await Promise.any([this.chatbotListStore.loadData(), this.callingStore.loadData()])
    setTimeout(() => {
      runInAction(() => {
        this._disabledLoadingOnMount = false
      })
    }, 100)
  }

  get initialLoading() {
    if (!this.isEmpty) {
      if (this.initType === 'texting') {
        return this.chatbotListStore.initialLoading
      }
      if (this.initType === 'calling') {
        return this.callingStore.initialLoading
      }
    }
    return this.chatbotListStore.initialLoading || this.callingStore.initialLoading
  }
  get isEmpty() {
    return this.chatbotListStore.isEmpty && this.callingStore.isEmpty
  }
}
